interface SmartDevice {
  id: string;
  name: string;
  type: 'light' | 'switch' | 'thermostat' | 'fan';
  state: {
    power?: boolean;
    brightness?: number;
    temperature?: number;
    speed?: number;
  };
}

export class AlexaSmartHome {
  private static instance: AlexaSmartHome;
  private alexaEndpoint: string;
  private skillToken: string;

  private constructor() {
    this.alexaEndpoint = 'https://api.amazonalexa.com/v3/events';
    this.skillToken = import.meta.env.VITE_ALEXA_SKILL_TOKEN || '';
  }

  static getInstance(): AlexaSmartHome {
    if (!AlexaSmartHome.instance) {
      AlexaSmartHome.instance = new AlexaSmartHome();
    }
    return AlexaSmartHome.instance;
  }

  async controlDevice(command: string): Promise<string> {
    try {
      // Analisa o comando
      const deviceMatch = command.match(/(?:ligar|desligar|ajustar|aumentar|diminuir) (?:a |o )?(.+)/i);
      if (!deviceMatch) return 'Comando não reconhecido';

      const device = deviceMatch[1].toLowerCase();
      const action = command.toLowerCase();

      // Monta o comando Alexa
      let alexaCommand = '';
      if (action.includes('ligar')) {
        alexaCommand = `Alexa, ligar ${device}`;
      } else if (action.includes('desligar')) {
        alexaCommand = `Alexa, desligar ${device}`;
      } else if (action.includes('ajustar')) {
        const level = command.match(/(\d+)%?/);
        if (level) {
          alexaCommand = `Alexa, ajustar ${device} para ${level[1]}%`;
        }
      }

      // Envia comando para a Alexa
      await this.sendToAlexa(alexaCommand);
      
      return 'Comando enviado com sucesso';
    } catch (error) {
      console.error('Erro ao controlar dispositivo:', error);
      return 'Erro ao executar comando';
    }
  }

  private async sendToAlexa(command: string): Promise<void> {
    const response = await fetch(this.alexaEndpoint, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${this.skillToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        event: {
          header: {
            namespace: 'Alexa.VoiceService',
            name: 'Speak',
            messageId: Date.now().toString()
          },
          payload: {
            text: command
          }
        }
      })
    });

    if (!response.ok) {
      throw new Error('Falha ao enviar comando para Alexa');
    }
  }

  async getDeviceStatus(deviceName: string): Promise<SmartDevice | null> {
    try {
      const response = await fetch(`${this.alexaEndpoint}/devices/${deviceName}`, {
        headers: {
          'Authorization': `Bearer ${this.skillToken}`
        }
      });

      if (!response.ok) return null;
      return await response.json();
    } catch {
      return null;
    }
  }
}

export const alexaSmartHome = AlexaSmartHome.getInstance();
